import styled from 'styled-components';

const SectionSubTitle = styled.div`
  color: var(--grey700);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
`;

export default SectionSubTitle;
